import React, {ReactElement, Fragment} from 'react'
import useAssets from '../hooks/useAssets'
import Select from 'react-select'
import useLookup from '../hooks/useLookup'
import {Asset} from "../../../types";

interface Props {
    label: string
}

export default function AssetSelector(props: Props): ReactElement {
    const [assets, loading] = useAssets()
    const [lookup, updateLookup] = useLookup('asset_name_event_type')

    return (
        <Fragment>
            {/* <AssetTestFilter assetOption={{}} selectedChannels={[{}]} /> */}
            <label htmlFor={'asset-selector'}>{props.label}</label>
            <Select
                role="change-asset"
                inputId={'asset-selector'}
                options={assets}
                loading={loading}
                labelKey={'name'}
                valueKey={'name'}
                value={lookup}
                onChange={(asset: Asset) => {
                    updateLookup([asset.name])
                }}
            />
        </Fragment>
    )
}
